import React from "react";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Loader;
